export default class CardEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#card_uuid") ? (elem.querySelector("#card_uuid") as HTMLInputElement).value : null,
            name: elem.querySelector("#card_name").value,
            access_room: elem.querySelector("#card_access_room").value
        }
    }
}